import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, reactive, watch } from 'vue';
import QueryParamsService, { QueryParams } from '../../../core/query-params.service';
import { useRoute, useRouter } from 'vue-router/composables';
import { watchRelativeUrl } from '@/core/route.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceToolbar',
  props: {
    startDate: null,
    endDate: null
  },
  emits: ["submit"],
  setup(__props: any, { emit }: { emit: ({(e: 'submit'): void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    startDate: Date,
    endDate: Date
}




const formData = reactive({
    startDate: null,
    endDate: null,
    invoiceNumber: null
});

const range = computed(() => ({
    start: formData.startDate,
    end: formData.endDate
}));

function updateRange(range) {
    if (range) {
        formData.startDate = range[0];
        formData.endDate = range[1];
    }
}

onMounted(updateSearchFields);

function updateSearchFields(): void {
    formData.startDate = QueryParamsService.getDateParam(QueryParams.InvoicesStartDate);
    formData.endDate = QueryParamsService.getDateParam(QueryParams.InvoicesEndDate);
    formData.invoiceNumber = QueryParamsService.getDateParam(QueryParams.InvoicesInvoiceNumber);

    if (!formData.startDate) {
        formData.startDate = props.startDate;
    }

    if (!formData.endDate) { formData.endDate = props.endDate; }

    updateQueryParams();
}

const router = useRouter();

function updateQueryParams() {
    const queryParams:Array<{name: string, value?: string, date?: Date}> = [
        { name: QueryParams.InvoicesStartDate, date: formData.startDate },
        { name: QueryParams.InvoicesEndDate, date: formData.endDate }
    ];

    if (formData.invoiceNumber !== null && formData.invoiceNumber !== undefined) {
        queryParams.push({ name: QueryParams.InvoicesInvoiceNumber, value: formData.invoiceNumber });
    }

    const query = QueryParamsService.appendQueryParams(queryParams);

    router.replace({ query });
}

function onFormSubmit() {
    updateQueryParams();
    emit('submit');
}

function onRelativeUrlChange(route: RelativeUrl, oldRoute: RelativeUrl) {
    // Don't update result when navigating away from result page
    if (route && oldRoute && route.path === oldRoute.path) {
        updateSearchFields();
    }
}

watchRelativeUrl(onRelativeUrlChange);

return { __sfc: true,props, emit, formData, range, updateRange, updateSearchFields, router, updateQueryParams, onFormSubmit, onRelativeUrlChange }
}

})